module.exports = __webpack_public_path__ + "img/OBCINA ILIRSKA BISTRICA.7ede82f9.png";